let highlight = function($sce) {
	return function(text, phrase) {
		if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
			'<span class="highlighted">$1</span>')
  
		return $sce.trustAsHtml(text)
	}
}

export default highlight;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/filters/highlight.filter.js